import { Authority } from '@/shared/security/authority';

const Activate = () => import('@/account/activate/activate.vue');
const PasswordPage = () => import('@/views/PasswordPage.vue');
const ChangePassword = () => import('@/account/change-password/change-password.vue');
const Settings = () => import('@/account/settings/settings.vue');

export default [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/LoginPage.vue'),
    },
    {
        path: '/account/activate/:key',
        name: 'Activate',
        component: Activate,
    },
    {
        path: '/account/reset/finish',
        name: 'ResetPasswordFinish',
        component: PasswordPage,
    },
    {
        path: '/account/password',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: { authorities: [Authority.USER] },
    },
    {
        path: '/account/settings',
        name: 'Settings',
        component: Settings,
        meta: { authorities: [Authority.USER] },
    },
];
